export function formatarEmReais(valorStr: string): string {
  try {
    // Converte a string para um número inteiro
    const numero: number = parseFloat(valorStr);

    // Verifica se a conversão foi bem-sucedida
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(numero)) {
      throw new Error("Valor inválido");
    }

    // Formata o número como uma string no formato de moeda brasileira
    const valorFormatado = numero.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return valorFormatado;
  } catch (error) {
    return "--";
  }
}

/**
 * Formata valor de input do usuário para formato de moeda brasileira
 * Remove caracteres não numéricos e formata automaticamente
 */
export function formatarInputMoeda(valorInput: string): string {
  // Remove tudo que não é número
  const numerosApenas = valorInput.replace(/\D/g, "");

  if (numerosApenas === "") return "";

  // Converte para número e divide por 100 para considerar centavos
  const numero = parseInt(numerosApenas, 10) / 100;

  // Formata como moeda brasileira
  return numero.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Extrai apenas os números de um valor formatado em moeda
 */
export function extrairNumerosMoeda(valorFormatado: string): string {
  return valorFormatado.replace(/\D/g, "");
}
